module.exports = __webpack_public_path__ + "static/Bootcamp-1-9dfd820f18fec30da88eb11794b3402c.jpg";